<wbo-search-page [showAddButton]="false">
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="sizeName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="valueName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="sizeName"></wbo-main-search-column>
        <wbo-column field="valueName"></wbo-column>
    </wbo-search-grid>
</wbo-search-page>
